import React, { Component, Fragment } from 'react';
import Wrapper from './../../../../../common/component/Wrapper';
import {
    getTitleTable, columnsTable,
    getDataSource, genaratePaginateFilterSort,
    getPermissionActions
} from '../../../../../../../helpers/functions';
import { parseListRequestParams, getLocaleFullName, getColumnVisibleConfigs } from '../../../../../../../utils/commonUtils';
import { generateStringId } from '../../../../../../../utils/orders';
import * as HMS from "../../../../../common/component/Index";
import * as Func from '../../../../../../../helpers/functions';
import SaleDetailReportByHotel from '../../../../../../../models/SaleDetailReportByHotel';
import DEFINE, { DATE_TIME_FORMAT, PATHS } from '../../../../../../../constants/Define';
import { ListComponent, DatePickerComponent } from '../../../../../common/component/Index';
import Button, { ButtonGroup } from '../../../../../common/component/Button';
import * as ANT from 'antd';
import { omit } from 'lodash';
import i18n from "../../../../../../../constants/initLng";
import Span from '../../../../../common/component/Span';
import moment from 'moment';
import EllipsisText from '../../../../../common/component/EllipsisText';
import { Link } from 'react-router-dom';

let permisionActions = [];
const defaultState = {
    filterExport: {}
};

const removeColumns = ["id", "orderId"];
const ReportListCols = [
    "id",
    "orderId",
    "orderCode",
    "createdDate",
    "checkInDate",
    "checkOutDate",
    "hotelName",
    "ratePlanName",
    "ratePlanCode",
    "promotionName",
    "roomType",
    "lengthOfStay",
    "adultQuantity",
    "childQuantity",
    "nationality",
    "priceRoom",
    "markUpPriceRoom",
    "salePrice",
    "couponValue",
    "surcharge",
    "surchargeDetail",
    "totalAmount",
    "couponCode",
    "memberShipCode",
    "transactionId",
    "paymentType",
    "bookingId",
    "saleChannel",
    "channel",
    "fullnameCustomer",
    "phoneNumberCustomer",
    "email",
    "fullname",
    "phoneNumber",
    "emailCustomer",
    "note"
]
const CURRENT_DATE_RANGE_ENUM = {
    DATE: [moment.utc().startOf('days'), moment.utc().endOf('days')],
    WEEK: [moment.utc().startOf('isoWeeks'), moment.utc().endOf('days')],
    MONTH: [moment.utc().startOf('months'), moment.utc().endOf('days')],
}
let orderOnline = ['onepay', 'vnpay', 'onepay_installment']
export default class ReportList extends Component {
    getSearchOption = () => {
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(ReportListCols, [], removeColumns),
            modelItem: ReportListCols,
            applyDateRanges: null,
            componentTable: {
                orderCode: {
                    key: 'orderCode',
                    ...this.getSearchOption(),
                    render: (text, record) => 
                            <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: record.orderId })} className={`mr-2 colorPrimary`}>
                                <Span>{text}</Span>
                            </Link>
                },
                createdDate: {
                    width: 140,
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.DATE_TIME),
                    sorter: (i, k) => i.createdDate - k.createdDate,
                },
                checkInDate: {
                    width: 140,
                    render: (text, record) => text && record.orderItemType !== 1 && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                    sorter: (i, k) => i.checkInDate - k.checkInDate,
                },
                checkOutDate: {
                    width: 150,
                    render: (text, record) => text && record.orderItemType !== 1 && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                    sorter: (i, k) => i.checkOutDate - k.checkOutDate,
                },
                hotelName: {
                    key: 'hotelName',
                    width: 300,
                    render: (text, record) => text,
                    ...this.getSearchOption(),
                },
                ratePlanName: {
                    key: 'ratePlanName',
                    width: 300,
                    render: (text, record) => text,
                    ...this.getSearchOption(),
                },
                ratePlanCode: {
                    key: 'ratePlanCode',
                    width: 150,
                    render: (text, record) => text,
                    ...this.getSearchOption(),
                },
                promotionName: {
                    key: 'promotionName',
                    render: (text, record) => text,
                    ...this.getSearchOption(),
                },
                roomType: {
                    key: 'roomType',
                    render: (text, record) => text,
                    ...this.getSearchOption(),
                },
                lengthOfStay: {
                    width: 150,
                    align: "right",
                },
                adultQuantity: {
                    visible: false,
                    width: 80,
                    align: "right",
                },
                childQuantity: {
                    visible: false,
                    width: 80,
                    align: "right",
                },
                nationality: {
                    key: 'nationality',
                    visible: false,
                    render: (text, record) => text,
                    ...this.getSearchOption(),
                },
                priceRoom: {
                    visible: false,
                    key: 'priceRoom',
                    width: 150,
                    align: "right",
                    render: (text) => Func.formatMoney(text),
                },
                markUpPriceRoom: {
                    visible: false,
                    width: 150,
                    align: "right",
                    render: (text) => Func.formatMoney(text)
                },
                salePrice: {
                    visible: false,
                    key: 'salePrice',
                    width: 150,
                    align: "right",
                    render: (text) => Func.formatMoney(text),
                },
                couponValue: {
                    visible: false,
                    width: 150,
                    align: "right",
                    render: (text) => Func.formatMoney(text)
                },
                surcharge: {
                    visible: false,
                    width: 150,
                    align: "right",
                    render: (text) => Func.formatMoney(text)
                },
                surchargeDetail: {
                    visible: false,
                    width: 150,
                    align: "right",
                    render: (text) => Func.formatMoney(text)
                },
                totalAmount: {
                    width: 110,
                    align: "right",
                    render: (amount) => Func.formatMoney(amount)
                },
                couponCode: {
                    key: 'couponCode',
                    ...this.getSearchOption(),
                    render: (text, record) => text
                },
                memberShipCode: {
                },
                transactionId: {
                    visible: false,
                    width: 200,
                },
                paymentType: {
                    visible: false,
                    key: 'paymentType',
                    render: (paymentType, data) => <Fragment>
                        {paymentType && <div className="g-mt-5">
                            <HMS.StatusComponent color={'gray'}
                                label={i18n.t(`item.order.paymentTypes.${data.paymentType}`)} />
                        </div>
                        }
                    </Fragment>,
                    sorter: (i, k) => i.paymentType - k.paymentType,
                },
                bookingId: {
                    key: 'bookingId',
                    ...this.getSearchOption(),
                    render: (text, record) => text
                },
                saleChannel: {
                    visible: false,
                    key: 'saleChannel',
                    render: (value, data) => value && i18n.t(`item.order.saleChannels.${value}`),
                    sorter: (i, k) => i.saleChannel - k.saleChannel,
                },
                channel: {
                    key: 'channel',
                    render: (value, data) => value && i18n.t(`item.order.channels.${value}`),
                    sorter: (i, k) => i.channel - k.channel,
                },
                fullnameCustomer: {
                    key: 'fullnameCustomer',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                phoneNumberCustomer: {
                    key: 'phoneNumberCustomer',
                    render: (text, record) => text,
                    ...this.getSearchOption(),
                },
                email: {
                    visible: false,
                    key: 'email',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                fullname: {
                    visible: false,
                    key: 'fullname',
                    render: (text, data) => data.fullname || getLocaleFullName(data.firstname, data.lastname),
                    ...this.getSearchOption(),
                },
                phoneNumber: {
                    visible: false,
                    key: 'phoneNumber',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                emailCustomer: {
                    key: 'emailCustomer',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                    ...this.getSearchOption(),
                },
                note: {
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />,
                },
            },
        };
    }

    componentDidMount() {
        permisionActions = getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ORDER_DETAIL_REPORT_BY_HOTEL);
    }

    render() {
        const { t, report, downloading } = this.props;

        return (
            <Wrapper className="col-md-12 p-0 mt-3 report-list order-detail-hotel">
                <Wrapper className="col-md-12 row m-0 p-0 report-list-title align-items-end">
                    <h3 className={`col-md-2 ml-0 p-0`}>{""}</h3>
                    <Wrapper className={`col-md-6 m-0 p-0 pr-2 button-section`}>
                        {permisionActions && permisionActions.allowExportFileExcel &&
                            <Button type="primary" onClick={() => this.onExportExcel(false)}
                                icon="download" loading={downloading}
                                disabled={!(report.items && report.items.length)}
                                className="mr-2">{t(`item.report.exportExcel`)}</Button>
                        }
                    </Wrapper>
                    <Wrapper className={`align-items-end col-md-4 d-flex flex-column m-0 p-0`}>
                        <ButtonGroup>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.DATE })}>{t(`item.report.currentDate`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.WEEK })}>{t(`item.report.currentWeek`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.MONTH })}>{t(`item.report.currentMonth`)}</Button>
                        </ButtonGroup>
                        <DatePickerComponent className={`form-control applyDates w100-percent mt-1`}
                            hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                            style={{ padding: 0, border: 0 }}
                            onChange={this.onSelectDateRange} name={`applyDates`}
                            placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                            value={[report.startDate, report.endDate]}
                            onCalendarChange={val => this.setState({...this.state, applyDateRanges: val })}
                            disabledDate={this.disabledDate}
                            onOpenChange={this.onOpenChange}
                        />
                    </Wrapper>
                </Wrapper>
                {this.renderList()}
            </Wrapper>
        );
    }

    renderList() {
        const { report, loading } = this.props;
        const { items } = report
        const filters = omit(report, 'items')
        const { titleItemTable, modelItem, componentTable } = this.state


        return (
            <Wrapper className={`mt-2`}>
                <ListComponent
                    tableKey="order-detail-report-hotel"
                    scroll={{ x: 5500 }}
                    classParent="m-0 p-0 sale-report-list"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => generateStringId(10)}
                    dataSource={getDataSource(items || [], modelItem)}
                    columns={columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'orderDetailReportHotel'
                    })}
                    pagination={{ total: filters.totalCount, totalPage: filters.totalPage, current: filters.pageIndex, pageSize: filters.pageSize }}
                    onChange={this.onTableChange}
                    componentTableList={{}}
                />
            </Wrapper>
        )
    }

    onSelectDateRange = (data) => {
        const filters = this.getCurrentFilters()
        filters.pageIndex = 1;
        filters.startDate = moment.utc(data.value[0], DATE_TIME_FORMAT.SHORT_DATE);
        filters.endDate = moment.utc(data.value[1], DATE_TIME_FORMAT.SHORT_DATE).endOf("day");
        if (filters.endDate.diff(filters.startDate, 'days') >= 31) {
            filters.endDate = filters.startDate.add(30, 'days')
        }
        return this.props.onChangeFilters({ ...this.state.filterExport, ...filters });
    }

    disabledDate = (current) => {
        const dates = this.state.applyDateRanges;
        if (!dates) {
          return false;
        }
        const tooLate = dates[0] && current.diff(dates[0], 'days') >= 31;
        const tooEarly = dates[0] && dates[0].diff(current, 'days') >= 31;
        return !!tooEarly || !!tooLate;
    };

    onOpenChange = (open) => {
        if (open) {
          this.setState([null, null]);
          this.setState({...this.state, applyDateRanges: [null, null]});
        }
    };

    onTableChange = (pagination, filters, sorter) => {
        const currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({ filterExport: newFilters })
        this.props.onChangeFilters(newFilters);
    };

    onChangeFilters = (fieldName, value) => {
        const filters = this.getCurrentFilters()
        filters[fieldName] = value;
        return this.props.onChangeFilters({ ...this.state.filterExport, ...filters })
    }

    onExportExcel = (isExcludeUserInfo = false) => {
        const { componentTable } = this.state;
        const defineColumns = Object.keys(componentTable).map(field => ({dataIndex: field, visible: componentTable[field]?.visible }));
        const visibledColumns = getColumnVisibleConfigs("order-detail-report-hotel", defineColumns);
        const filters = this.getCurrentFilters();
        filters.pageIndex = undefined;
        filters.pageSize = undefined;
        filters.isExcludeUserInfo = isExcludeUserInfo;
        filters.headerReport = visibledColumns.filter(x=> x.visible !== false).map(x=> x.dataIndex).join(",");
        return this.props.onExportExcel(parseListRequestParams({ ...this.state.filterExport, ...filters }));
    }

    getCurrentFilters() {
        const { report } = this.props;
        return omit(report, ['items', 'totalCount', 'totalPage']);
    }
}

ReportList.defaultProps = {
    report: new SaleDetailReportByHotel(),
    loading: false,
    downloading: false,
    onChangeFilters: filters => { },
    onExportExcel: filters => { },
}

